/* HWS24 – App-Navigation auf dem Handy (unter 750 px).
   Leiste unten (Start · Kategorien · Suche · Warenkorb), Kategorien-Menü als Sheet,
   Header und Leiste weichen beim Herunterscrollen aus und kommen beim Hochscrollen zurück.
   Ab 750 px greift nichts davon – Tablet und Desktop bleiben unverändert. */
(function () {
  'use strict';

  const phone = window.matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Kurzes Vibrieren beim Tippen (Android; iOS Safari kennt die Vibration-API nicht)
  function haptic(ms) {
    try { if (navigator.vibrate) navigator.vibrate(ms || 8); } catch (e) { /* nicht unterstützt */ }
  }

  function overlayOpen() {
    return document.body.classList.contains('overflow-hidden') || root.classList.contains('hws-menu-open') || root.classList.contains('hws-dialog-open');
  }

  /* ---------- Header & Leiste beim Scrollen aus- und einblenden ---------- */
  let showBars = () => {};
  function initBars() {
    let last = window.scrollY;
    let ignoreUntil = 0;
    let ticking = false;
    const update = () => {
      ticking = false;
      const y = Math.max(0, window.scrollY);
      if (!phone.matches || performance.now() < ignoreUntil || overlayOpen()) {
        if (!phone.matches) root.classList.remove('hws-bars-hidden');
        last = y;
        return;
      }
      const delta = y - last;
      if (Math.abs(delta) < 8) return;
      // Nie ganz oben und nie ganz unten ausblenden (dort erwartet man die Leiste)
      const atBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 8;
      root.classList.toggle('hws-bars-hidden', delta > 0 && y > 140 && !atBottom);
      last = y;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    showBars = (hold = 450) => {
      root.classList.remove('hws-bars-hidden');
      ignoreUntil = performance.now() + hold;
      last = window.scrollY;
    };
    window.addEventListener('pageshow', () => showBars(600));
    phone.addEventListener('change', () => showBars(0));
  }

  /* ---------- Höhe des Headers als CSS-Variable (für klebende Leisten darunter) ---------- */
  function initHeaderHeight() {
    const header = document.querySelector('.section-header');
    if (!header || !('ResizeObserver' in window)) return;
    const set = () => root.style.setProperty('--hws-header-h', `${header.offsetHeight}px`);
    new ResizeObserver(set).observe(header);
    set();
  }

  /* ---------- Warenkorb-Zähler in der Leiste spiegelt das Header-Symbol ---------- */
  function initCartCount() {
    const badges = document.querySelectorAll('[data-hws-cart-count]');
    const bubble = document.getElementById('cart-icon-bubble');
    if (!badges.length || !bubble) return;
    let previous = null;
    const read = () => {
      const el = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      const count = el ? parseInt(el.textContent, 10) || 0 : 0;
      badges.forEach((badge) => {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
        if (previous !== null && count > previous && !reduceMotion) {
          badge.classList.remove('is-bumped');
          void badge.offsetWidth;
          badge.classList.add('is-bumped');
        }
      });
      if (previous !== null && count > previous) showBars(1200);
      previous = count;
    };
    read();
    new MutationObserver(read).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- Suche öffnen (vorhandenes Such-Overlay im Header) ---------- */
  function openSearch() {
    const modal = document.querySelector('.header > details-modal.header__search') || document.querySelector('details-modal.header__search');
    if (!modal || typeof modal.open !== 'function') return false;
    showBars(800);
    const details = modal.querySelector('details');
    if (details.hasAttribute('open')) {
      const input = details.querySelector('input[type="search"]');
      if (input) input.focus();
      return true;
    }
    modal.open({ target: modal.querySelector('summary') });
    return true;
  }

  /* ---------- Warenkorb als Sheet öffnen ---------- */
  function openCart(trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return false;
    drawer.open(trigger);
    return true;
  }

  /* ---------- Menüs als Sheet von unten: „Kategorien" (#HwsMenu) und „Service" (#HwsService) ----------
     Immer nur eines offen; menu.dialog ist das gerade offene. */
  const menu = { dialog: null, trigger: null };
  const triggersOf = (dialog) => document.querySelectorAll(`[data-hws-menu-open][aria-controls="${dialog.id}"]`);
  const dialogOf = (trigger) => document.getElementById((trigger && trigger.getAttribute('aria-controls')) || 'HwsMenu');
  function closeMenu(instant) {
    const dialog = menu.dialog;
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    const done = () => {
      dialog.classList.remove('is-closing', 'is-open');
      dialog.style.removeProperty('--hws-drag');
      dialog.close();
    };
    if (instant || reduceMotion) return done();
    dialog.classList.add('is-closing');
    setTimeout(done, 240);
  }
  function openMenu(trigger) {
    const dialog = dialogOf(trigger);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.open) return true;
    if (menu.dialog && menu.dialog !== dialog && menu.dialog.open) closeMenu(true);
    menu.dialog = dialog;
    menu.trigger = trigger || null;
    showBars(0);
    dialog.classList.remove('is-open');
    dialog.showModal();
    dialog.scrollTop = 0; // falls der Browser zum fokussierten Feld gescrollt hat
    root.classList.add('hws-menu-open');
    // erst nach dem teuren ersten Bild hochfahren (siehe hws-mobile.css → .hws-menu__sheet)
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-open')));
    triggersOf(dialog).forEach((el) => el.setAttribute('aria-expanded', 'true'));
    const body = dialog.querySelector('.hws-menu__body');
    if (body) body.scrollTop = 0;
    return true;
  }
  function initMenu() {
    document.querySelectorAll('dialog[data-hws-menu]').forEach(initSheet);
    // Zurück-Navigation aus dem Cache: kein Menü offen stehen lassen
    window.addEventListener('pageshow', () => closeMenu(true));
  }
  function initSheet(dialog) {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = '1';
    if (!menu.dialog) menu.dialog = dialog;
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[data-hws-menu][open]')) root.classList.remove('hws-menu-open');
      triggersOf(dialog).forEach((el) => el.setAttribute('aria-expanded', 'false'));
    });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeMenu(); });
    // Der Dialog selbst darf nie verschoben werden (nur die Liste im Sheet scrollt)
    dialog.addEventListener('scroll', () => { if (dialog.scrollTop) dialog.scrollTop = 0; }, { passive: true });
    // Tippen auf den abgedunkelten Bereich über dem Sheet schließt
    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeMenu(); });

    // Nach unten ziehen schließt (wie in den HWS24-Apps)
    const sheet = dialog.querySelector('.hws-menu__sheet');
    let start = null;
    dialog.querySelectorAll('[data-hws-menu-drag]').forEach((handle) => {
      handle.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || event.target.closest('button, a')) return;
        start = { y: event.clientY, t: performance.now(), dy: 0 };
        handle.setPointerCapture(event.pointerId);
        sheet.classList.add('is-dragging');
      });
      handle.addEventListener('pointermove', (event) => {
        if (!start) return;
        start.dy = Math.max(0, event.clientY - start.y);
        dialog.style.setProperty('--hws-drag', `${start.dy}px`);
      });
      const end = () => {
        if (!start) return;
        const velocity = start.dy / Math.max(1, performance.now() - start.t);
        const shouldClose = start.dy > 110 || velocity > 0.6;
        start = null;
        sheet.classList.remove('is-dragging');
        if (shouldClose) closeMenu();
        else dialog.style.removeProperty('--hws-drag');
      };
      handle.addEventListener('pointerup', end);
      handle.addEventListener('pointercancel', end);
    });
  }

  /* ---------- Zentrale Klick-Steuerung (auf document, damit Dawns Overlays nicht sofort wieder schließen) ---------- */
  function initClicks() {
    document.addEventListener('click', (event) => {
      if (!phone.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey) return;
      const target = event.target.closest('[data-hws-menu-open], [data-hws-menu-close], [data-hws-search-open], [data-hws-cart-open]');
      if (!target) return;

      if (target.hasAttribute('data-hws-menu-close')) {
        event.preventDefault();
        closeMenu();
        return;
      }
      if (target.hasAttribute('data-hws-menu-open')) {
        const wanted = dialogOf(target);
        if (wanted && wanted.open) { event.preventDefault(); closeMenu(); return; }
        if (openMenu(target)) { event.preventDefault(); haptic(); }
        return;
      }
      if (target.hasAttribute('data-hws-search-open')) {
        if (menu.dialog && menu.dialog.open) closeMenu(true);
        if (openSearch()) { event.preventDefault(); haptic(); }
        return;
      }
      if (target.hasAttribute('data-hws-cart-open')) {
        if (document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname)) return;
        if (openCart(target)) { event.preventDefault(); haptic(); }
      }
    });

    // Leisten-Tipps auf Android fühlbar machen
    document.addEventListener('click', (event) => {
      if (phone.matches && event.target.closest('.hws-tabbar__item, .hws-list__row, .hws-chiprow a')) haptic(6);
    }, true);
  }

  /* ---------- Nachgeladene Modell-Auswahl: Lieferzeit-Hinweis & Co. einrichten ---------- */
  function initQuickAdd() {
    document.querySelectorAll('.quick-add-modal__content-info').forEach((info) => {
      if (info.dataset.hwsWatch) return;
      info.dataset.hwsWatch = '1';
      new MutationObserver(() => {
        if (!info.children.length || typeof window.hwsInit !== 'function') return;
        window.hwsInit(info);
      }).observe(info, { childList: true });
    });
  }

  /* ---------- Installierte App: Zurück-Knopf im Header (iPhone hat keinen System-Zurück-Knopf) ---------- */
  function initStandaloneBack() {
    if (!root.classList.contains('hws-standalone')) return;
    const main = document.getElementById('MainContent');
    if (!phone.matches || (main && main.dataset.template === 'index')) return;
    const header = document.querySelector('.section-header .header');
    const tpl = document.getElementById('HwsBackTpl');
    if (!header || !tpl || header.querySelector('.hws-back')) return;
    const button = tpl.content.firstElementChild.cloneNode(true);
    button.addEventListener('click', () => {
      haptic();
      let sameOrigin = false;
      try { sameOrigin = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) { /* ungültiger Referrer */ }
      if (sameOrigin && history.length > 1) history.back();
      else location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    });
    header.prepend(button);
  }

  /* ---------- Kundenstimmen: wischbar, blättert langsam weiter (nur Handy) ---------- */
  function initReviewSwipe() {
    const strip = document.querySelector('.hws-reviews__marquee');
    if (!strip || strip.dataset.hwsSwipe || reduceMotion) return;
    strip.dataset.hwsSwipe = '1';
    let pausedUntil = 0;
    let inView = false;
    const pause = () => { pausedUntil = performance.now() + 8000; };
    ['touchstart', 'pointerdown', 'wheel'].forEach((type) => strip.addEventListener(type, pause, { passive: true }));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => { inView = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(strip);
    }
    setInterval(() => {
      if (!phone.matches || !inView || document.hidden || performance.now() < pausedUntil) return;
      const card = strip.querySelector('.hws-reviews__group > li');
      if (!card) return;
      const step = card.getBoundingClientRect().width + 12;
      const atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 8;
      strip.scrollTo({ left: atEnd ? 0 : strip.scrollLeft + step, behavior: 'smooth' });
    }, 4500);
  }

  /* ---------- Warenkorb: Wischen (Handy) – rechts = für später merken, links = löschen ---------- */
  const STRINGS = (() => { try { return JSON.parse(document.getElementById('HwsAppStrings').textContent); } catch (e) { return {}; } })();
  const SAVED_KEY = 'hws-saved';
  const readSaved = () => { try { return JSON.parse(localStorage.getItem(SAVED_KEY)) || []; } catch (e) { return []; } };
  const writeSaved = (list) => { try { localStorage.setItem(SAVED_KEY, JSON.stringify(list.slice(0, 30))); } catch (e) { /* Speicher voll/gesperrt */ } };
  const esc = (v) => String(v || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  let toastTimer = 0;
  function toast(text, actionLabel, onAction) {
    let el = document.getElementById('HwsToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'HwsToast';
      el.className = 'hws-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = `<span>${esc(text)}</span>${actionLabel ? `<button type="button">${esc(actionLabel)}</button>` : ''}`;
    if (actionLabel) el.querySelector('button').addEventListener('click', () => { el.classList.remove('is-visible'); onAction(); }, { once: true });
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 5000);
  }

  // Warenkorb neu laden (Schublade + Zähler; auf der Warenkorb-Seite ganze Seite)
  function addToCart(variantId, quantity) {
    const drawer = document.querySelector('cart-drawer');
    const onCartPage = !!document.querySelector('main[data-template="cart"]');
    return fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }),
    })
      .then((r) => r.json())
      .then((state) => {
        if (state.status) throw new Error(state.description || state.message);
        if (onCartPage) { location.reload(); return; }
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
      });
  }

  function lineData(row) {
    const d = row.dataset;
    return { v: d.hwsVariant, q: parseInt(d.hwsQty, 10) || 1, t: d.hwsTitle, vt: d.hwsVtitle, u: d.hwsUrl, img: d.hwsImage, p: d.hwsPrice };
  }
  function removeRow(row) {
    const btn = row.querySelector('cart-remove-button');
    if (btn) btn.click();
  }

  function renderSaved() {
    const list = readSaved();
    const hosts = [];
    const drawerItems = document.querySelector('cart-drawer cart-drawer-items');
    const drawerEmpty = document.querySelector('cart-drawer .drawer__inner-empty');
    if (drawerItems && !drawerItems.classList.contains('is-empty')) hosts.push(['after', drawerItems]);
    else if (drawerEmpty) hosts.push(['append', drawerEmpty]);
    const pageItems = document.querySelector('main[data-template="cart"] cart-items .page-width');
    if (pageItems) hosts.push(['append', pageItems]);
    hosts.forEach(([mode, host]) => {
      const scope = mode === 'after' ? host.parentElement : host;
      let box = scope.querySelector(':scope > .hws-saved');
      if (!list.length) { if (box) box.remove(); return; }
      if (!box) {
        box = document.createElement('section');
        box.className = 'hws-saved';
        if (mode === 'after') host.after(box); else host.appendChild(box);
      }
      box.innerHTML = `<h3 class="hws-saved__title">${esc(STRINGS.savedTitle)} <span>${list.length}</span></h3><ul class="hws-saved__list" role="list">${list.map((it) => `
        <li class="hws-saved__item" data-v="${esc(it.v)}">
          <a class="hws-saved__img" href="${esc(it.u)}">${it.img ? `<img src="${esc(it.img)}" alt="" loading="lazy" width="64" height="64">` : ''}</a>
          <div class="hws-saved__info"><a href="${esc(it.u)}">${esc(it.t)}</a>${it.vt ? `<small>${esc(it.vt)}</small>` : ''}<strong>${esc(it.p)}</strong></div>
          <div class="hws-saved__actions">
            <button type="button" class="hws-saved__move" data-hws-saved-move>${esc(STRINGS.move)}</button>
            <button type="button" class="hws-saved__remove" data-hws-saved-remove aria-label="${esc(STRINGS.remove)}">×</button>
          </div>
        </li>`).join('')}</ul>`;
    });
  }

  function initSaved() {
    if (document.documentElement.dataset.hwsSavedReady) return;
    document.documentElement.dataset.hwsSavedReady = '1';
    document.addEventListener('click', (event) => {
      const move = event.target.closest('[data-hws-saved-move]');
      const rem = event.target.closest('[data-hws-saved-remove]');
      if (!move && !rem) return;
      const item = event.target.closest('.hws-saved__item');
      const v = item && item.dataset.v;
      writeSaved(readSaved().filter((it) => String(it.v) !== String(v)));
      if (rem) { renderSaved(); return; }
      move.disabled = true;
      addToCart(v, 1).then(() => { renderSaved(); toast(STRINGS.added); }).catch(() => { move.disabled = false; renderSaved(); });
    });
    // Schublade/Seite werden nach jeder Änderung neu gerendert → Liste und Wischen neu einrichten
    let pending = 0;
    const refresh = () => { cancelAnimationFrame(pending); pending = requestAnimationFrame(() => { renderSaved(); bindSwipes(); }); };
    ['cart-drawer', 'main[data-template="cart"]'].forEach((sel) => {
      const el = document.querySelector(sel);
      if (el) new MutationObserver((records) => { if (records.some((r) => !r.target.closest || !r.target.closest('.hws-saved'))) refresh(); }).observe(el, { childList: true, subtree: true });
    });
    refresh();
  }

  function bindSwipes() {
    if (!phone.matches) return;
    document.querySelectorAll('.cart-item[data-hws-line]').forEach((row) => {
      if (row.dataset.hwsSwipe) return;
      row.dataset.hwsSwipe = '1';
      const bgSave = document.createElement('span');
      bgSave.className = 'hws-swipe-bg hws-swipe-bg--save';
      bgSave.innerHTML = `<span>${esc(STRINGS.saveAction)}</span>`;
      const bgDel = document.createElement('span');
      bgDel.className = 'hws-swipe-bg hws-swipe-bg--del';
      bgDel.innerHTML = `<span>${esc(STRINGS.deleteAction)}</span>`;
      row.append(bgSave, bgDel);
      let start = null;
      let axis = null;
      let dx = 0;
      let armed = false;
      let suppressUntil = 0;
      const set = (x) => { row.style.setProperty('--hws-sx', `${x}px`); };
      row.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'touch' || e.target.closest('input, quantity-input, .quantity')) return;
        start = { x: e.clientX, y: e.clientY }; axis = null; dx = 0; armed = false;
      });
      row.addEventListener('pointermove', (e) => {
        if (!start) return;
        const mx = e.clientX - start.x; const my = e.clientY - start.y;
        if (!axis && Math.hypot(mx, my) > 10) axis = Math.abs(mx) > Math.abs(my) * 1.3 ? 'x' : 'y';
        if (axis !== 'x') return;
        row.classList.add('hws-swiping');
        dx = mx;
        set(dx);
        const limit = row.offsetWidth * 0.35;
        const nowArmed = Math.abs(dx) > limit;
        if (nowArmed !== armed) { armed = nowArmed; row.classList.toggle('is-armed', armed); haptic(10); }
      });
      const end = () => {
        if (!start) return;
        start = null;
        if (axis !== 'x') return;
        suppressUntil = performance.now() + 450;
        row.classList.remove('is-armed');
        if (!armed) { row.classList.add('hws-swipe-back'); set(0); setTimeout(() => row.classList.remove('hws-swiping', 'hws-swipe-back'), 260); return; }
        const data = lineData(row);
        row.classList.add('hws-swipe-out');
        set(dx > 0 ? row.offsetWidth : -row.offsetWidth);
        try { localStorage.setItem('hws-swipe-learned', '1'); } catch (err) { /* egal */ }
        setTimeout(() => {
          removeRow(row);
          if (dx > 0) {
            writeSaved([data].concat(readSaved().filter((it) => String(it.v) !== String(data.v))));
            toast(STRINGS.saved);
          } else {
            toast(STRINGS.removed, STRINGS.undo, () => addToCart(data.v, data.q).then(() => toast(STRINGS.added)));
          }
        }, 220);
      };
      row.addEventListener('pointerup', end);
      row.addEventListener('pointercancel', end);
      // Nach einem Wisch keinen Link öffnen
      row.addEventListener('click', (e) => { if (e.isTrusted && performance.now() < suppressUntil) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
    // Einmaliger Hinweis über der Liste
    let learned = false;
    try { learned = !!localStorage.getItem('hws-swipe-learned'); } catch (e) { /* egal */ }
    document.querySelectorAll('cart-drawer-items .drawer__contents, main[data-template="cart"] .cart__items').forEach((box) => {
      if (learned || box.querySelector('.hws-swipe-hint') || !box.querySelector('.cart-item[data-hws-line]')) return;
      const hint = document.createElement('p');
      hint.className = 'hws-swipe-hint';
      hint.textContent = STRINGS.hint;
      box.prepend(hint);
    });
  }

  /* ---------- „Zur Kasse gehen (n Artikel)“ auf der Warenkorb-Seite aktuell halten ---------- */
  function initCheckoutCount() {
    const btn = document.querySelector('[data-hws-checkout]');
    // PUB_SUB_EVENTS ist eine globale const aus constants.js (lädt vorher) – keine window-Eigenschaft
    if (!btn || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const n = event && event.cartData && event.cartData.item_count;
      if (typeof n !== 'number') return;
      btn.textContent = n === 1 ? btn.dataset.one : btn.dataset.other.replace('__COUNT__', n);
    });
  }

  function safe(fn) {
    try { fn(); } catch (error) { console.error('[HWS24 App]', error); }
  }

  function init() {
    safe(initBars);
    safe(initHeaderHeight);
    safe(initCartCount);
    safe(initMenu);
    safe(initClicks);
    safe(initQuickAdd);
    safe(initStandaloneBack);
    safe(initReviewSwipe);
    safe(initSaved);
    safe(initCheckoutCount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
